import { AddIcon } from "@chakra-ui/icons";
import { Box, Button, HStack, Image, Text, VStack } from "@chakra-ui/react";
import { StepProps } from "./CreateCampaignWizard";
import Navigation from "./Navigation";

const AdsetList = ({
  campaign,
  navigateTo,
  next,
  back,
  setDefaultEditingAdset,
}: StepProps) => {
  return (
    <VStack w="full" gap={4}>
      <HStack w="full" gap={4}>
        {campaign?.adsets.map((adset) => (
          <Box
            key={adset.id}
            position={"relative"}
            aspectRatio={1}
            backgroundColor={"gray.100"}
            rounded="xl"
            width={60}
            height={60}
            overflow={"hidden"}
            justifyContent={"center"}
            alignItems={"center"}
            onClick={() => {
              setDefaultEditingAdset(adset);
              navigateTo("adset");
            }}
          >
            <Image
              src={adset.ads?.[0]?.creative?.images?.[0]?.picture_url}
              outline={"none"}
              border={"none"}
              height={"100%"}
              width={"100%"}
              backgroundColor={"gray.100"}
              objectFit={"cover"}
            />
            <Box
              alignItems={"center"}
              justifyContent={"center"}
              pos={"absolute"}
              bottom={0}
              py={1}
              w="full"
              display={"flex"}
              backgroundColor={"rgba(255,255,255,0.5)"}
            >
              <Text w="full" fontWeight={"bold"}>
                {adset.name}
              </Text>
            </Box>
          </Box>
        ))}
        <Button
          height={60}
          flexDirection={"column"}
          gap={4}
          rounded="xl"
          onClick={() => {
            navigateTo("create_adset");
          }}
          width={60}
        >
          <AddIcon fontSize={"2xl"} />
          New adset
        </Button>
      </HStack>
    </VStack>
  );
};

export default AdsetList;
